'use client';

import styles from './SCarDetaiHeroSection.module.scss';
import { useMediaQuery } from 'usehooks-ts';

const SCarDetailHeroSection = ({ data }) => {
  // 添加安全检查，防止data为undefined时的解构错误
  if (!data) {
    return (
      <div className={styles.heroSection} data-aos="fade-up">
        <p>No hero data available.</p>
      </div>
    );
  }

  const { title, desc, buttonUrl, buttonText, buttonTextLaptop, image } = data;

  const xl = useMediaQuery('(max-width: 834px)');

  // 获取图片URL - 根据设备类型选择
  const getImageUrl = () => {
    if (!image?.fields) return '';

    // 优先使用desktopImage，如果没有则使用mobileImage
    const desktopImage = image.fields.desktopImage?.value?.src;
    const mobileImage = image.fields.mobileImage?.value?.src;
    const tabletImage = image.fields.tabletImage?.value?.src;

    if (xl && mobileImage) return mobileImage;
    if (tabletImage) return tabletImage;
    return desktopImage || mobileImage || '';
  };

  const imageUrl = getImageUrl();

  return (
    <div className={styles.heroSection} data-aos="fade-up">
      <div className={styles.content}>
        <h1 className={styles.title}>{title}</h1>
        {desc && <div className={styles.description} dangerouslySetInnerHTML={{ __html: desc }} />}
        {buttonUrl && (
          <a href={buttonUrl} className={styles.button}>
            {xl ? buttonTextLaptop : buttonText}
          </a>
        )}
      </div>

      {imageUrl && (
        <div className={styles.imageWrapper}>
          <img src={imageUrl} alt={title || 'Hero Image'} />
        </div>
      )}
    </div>
  );
};

export default SCarDetailHeroSection;
